<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 15.5714H12V13.6429H8V15.5714ZM1 4V5.92857H19V4H1ZM4 10.75H16V8.82143H4V10.75Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
export default defineNuxtComponent({
  props: {
    size: {
      type: Number,
      default: 40
    },
    variant: {
      type: String,
      default: 'dark' // light, dark
    },
  },
  setup(props) {
    const color = (() => {
      if (props.variant === 'dark') {
        return '#151515'
      }
      if (props.variant === 'light') {
        return '#e5e5e5'
      }

      // Default: light
      return '#e5e5e5'
    })()
    
    return {
      color,
    }
  }
})
</script>
